import React from 'react';
import './page404.scss';


const Page404 = () => (
  <div className="page page-404">
    <h1>404</h1>
  </div>
);

export default Page404;



// WEBPACK FOOTER //
// /Users/balazskaxd/dev/rkk/rkk-webapp/src/routes/Page404/components/Page404.js